import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: title */
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={800}
    height={800}
    viewBox="0 0 32 32"
    {...props}
    fill="none"
    stroke="none"
  >
    <Path
      fill={props.fill || '#000'}
      fillRule="evenodd"
      d="M31.685.3c-.182-.18-.434-.3-.713-.3H22a1.001 1.001 0 0 0 0 2h6.629L17.83 12.8l1.414 1.41L30.031 3.42 30 10a1.001 1.001 0 0 0 2 0V1c0-.3-.122-.54-.315-.7ZM12.756 17.79 1.969 28.58 2 22a1.001 1.001 0 0 0-2 0v9c0 .3.122.54.315.7.182.18.434.3.713.3H10a1.001 1.001 0 0 0 0-2H3.371L14.17 19.2l-1.414-1.41Z"
    />
  </Svg>
)
export default SvgComponent
